// extracted by mini-css-extract-plugin
export var divider = "_13-0";
export var dividerText = "_13-1";